import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';

import {
  CREATE_COMPONENT_COMPONENT_SELECTED,
  CREATE_DUPLICATE_COMPONENT,
  GET_EXISTING_COMPONENTS_FULLFILLED,
  GET_IMAGE_SIZE_FOR_COMPONENT_RESPONSE
} from 'app/CanvasComponent/const';
import { COMPONENT_MODIFIED } from 'app/EditorPane/const';
import { CLEAR_PAGE_API_RESPONSE, PAGE_PUBLISH_REJECTED } from 'app/PageButtonsList/const';
import {
  API_COMPONENT_ACTION_MODIFIED,
  recursivelyModifyComponent,
  slidePageUnderTheComponent
} from 'utils/factory';

import {
  ADD_COMPONENT_TO_PAGE,
  CHANGE_PAGE_PROPERTY,
  CREATE_UNSAVED_PAGE,
  DELETE_PAGE_REJECTED,
  DUPLICATE_PAGE,
  GET_PAGE_SUCCESS,
  PAGE_COMPONENTS_LIST_CHANGED,
  REMOVE_ACTIVE_PAGE,
  REMOVE_COMPONENT_FROM_PAGE,
  REPLACE_COMPONENT_ON_THE_PAGE,
  SAVE_PAGE_FAILURE
} from './const';

export const defaultState = {
  payload: {}
};

/**
 * page reducer
 * @param  {object} [state=defaultState] - the state
 * @param  {object} [action={}] - action object
 * @returns {object} updated state object
 */
const reducer = function pageReducer(state = defaultState, action = {}) {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case CREATE_COMPONENT_COMPONENT_SELECTED:
    case CREATE_DUPLICATE_COMPONENT:
    case GET_EXISTING_COMPONENTS_FULLFILLED: {
      const component = {
        ...action.component
      };
      const page = slidePageUnderTheComponent(component);
      return {
        ...state,
        payload: page
      };
    }
    case DELETE_PAGE_REJECTED:
      console.warn(`delete page request failed with error (${action.error})`);
      return state;
    case DUPLICATE_PAGE:
      return {
        ...state,
        payload: {
          ...action.pagePayload
        }
      };
    case GET_PAGE_SUCCESS:
      return {
        ...state,
        payload: {
          ...action.page
        }
      };
    case CREATE_UNSAVED_PAGE:
      return { ...state, payload: action.payload };
    case GET_IMAGE_SIZE_FOR_COMPONENT_RESPONSE:
    case COMPONENT_MODIFIED: {
      if (
        !state ||
        !state.payload ||
        !state.payload.Payload ||
        !state.payload.Payload.Components ||
        !action.id
      ) {
        return state;
      }
      const payload = recursivelyModifyComponent(cloneDeep(state.payload), {
        ...action,
        Action: API_COMPONENT_ACTION_MODIFIED
      });

      return {
        ...state,
        payload
      };
    }
    case ADD_COMPONENT_TO_PAGE: {
      const components = state.payload?.Payload?.Components ?? [];
      const { component, position } = action;
      const index = position >= 0 ? position : components.length + 1;

      return {
        ...state,
        payload: {
          ...state.payload,
          Payload: {
            ...state.payload.Payload,
            Components: components.slice(0, index).concat(component, components.slice(index))
          }
        }
      };
    }
    case REPLACE_COMPONENT_ON_THE_PAGE: {
      const componentsList = [...state.payload.Payload.Components];
      componentsList[action.index] = action.component;
      return {
        ...state,
        payload: {
          ...state.payload,
          Payload: {
            ...state.payload.Payload,
            Components: componentsList
          }
        }
      };
    }
    case REMOVE_COMPONENT_FROM_PAGE: {
      const newComponentsList = state.payload.Payload.Components
        ? [...state.payload.Payload.Components]
        : [];
      const deleteComponentIndex = newComponentsList.lastIndexOf(
        component => action.id === component.Id
      );

      newComponentsList.splice(deleteComponentIndex, 1);

      return {
        ...state,
        payload: {
          ...state.payload,
          Payload: {
            ...state.payload.Payload,
            Components: newComponentsList
          }
        }
      };
    }
    case REMOVE_ACTIVE_PAGE:
      return null;
    case PAGE_COMPONENTS_LIST_CHANGED:
      return {
        ...state,
        payload: {
          ...state.payload,
          Payload: {
            ...state.payload.Payload,
            Components: action.ComponentList
          }
        }
      };
    case CHANGE_PAGE_PROPERTY: {
      const payload = cloneDeep(state.payload);
      set(payload, action.field, action.value);
      return {
        ...state,
        payload
      };
    }
    case SAVE_PAGE_FAILURE:
    case PAGE_PUBLISH_REJECTED: {
      const { body } = action.error;
      return {
        ...state,
        apiResponse: body
      };
    }
    case CLEAR_PAGE_API_RESPONSE: {
      return {
        ...state,
        apiResponse: undefined
      };
    }
    default:
      return state;
  }
};

export default reducer;
